export default __webpack_public_path__ + "static/media/completion.ff2b3b6a.svg";